import { Link } from "@omni/ui/components/CallToAction/types/link.types";
import { PropsWithChildren } from "react";

import { useCallToActionContext } from "../../callToAction.context";

type LinkCallToAcitonProps = PropsWithChildren<{
    link: Link;
}>;

const LinkCallToAction = (props: LinkCallToAcitonProps) => {
    const { link, children } = props;

    const { trackingProperties, styleProperties } = useCallToActionContext();

    return (
        <a
            {...link}
            {...trackingProperties.click}
            {...styleProperties.link}
        >
            {children}
        </a>
    );
};

export { LinkCallToAction };
